import { AxiosPromise } from 'axios';
import { ISettingsFormValues } from '../form';
import { instance } from '../../../../services';

const updateSettings = (data: ISettingsFormValues): AxiosPromise => {
  return instance.put('api/settings', data);
};

export default updateSettings;
